import Vue from "vue";
import * as Sentry from "@sentry/vue";
import package_json from "../../package.json";
import router from "../router";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    Vue,
    dsn: "https://138c98fe3fff29f4a27ca4d6a56bd4f7@sentry.home.eumera.de/3",
    integrations: [
      Sentry.browserTracingIntegration(router),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      }),
      Sentry.feedbackIntegration({
        // Additional SDK configuration goes in here, for example:
        colorScheme: "light",
        autoInject: false,
        showBranding: false,
        showName: false,
        showEmail: false,
        formTitle: "Fehler melden",
        messageLabel: "Beschreibung",
        messagePlaceholder: "",
        successMessageText: "Vielen Dank für Ihre Nachricht.",
        cancelButtonLabel: "Abbrechen",
        submitButtonLabel: "Bericht senden"
      })
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

    release: "swym-manager@" + package_json.version,
    beforeSend(event) {
      // Check if it is an exception, and if so, show the report dialog
      if (event.exception) {
        Sentry.showReportDialog({
          eventId: event.event_id
        });
      }
      return event;
    }
  });
}
